/**
 * Scale/Edit modal – right leads column.
 * For Media Devoted | Created By Ciro Autiero
 */

import { Users } from 'lucide-react';

import { LeadsPickerSection } from '@/features/smswiser-campaigns/components/drop-modals';
import { ColumnHeader } from '../../shared';
import type { useScaleDropForm } from '../../useScaleDropForm';
import type { ScaleDropModalProps } from '../../ScaleDropModal.types';

interface Props {
  isMulti: boolean;
  form: ReturnType<typeof useScaleDropForm>;
  enrichedLeads: ScaleDropModalProps['leadsLists'];
  perfTagsQuery: { data?: { tagColors?: Record<string, string> }; isLoading: boolean };
  tagFilterOptions: string[];
  scaleUsageByListId: Record<string, number>;
}

export function ScaleOrEditLeadsColumn(props: Props) {
  const { isMulti, form, enrichedLeads, perfTagsQuery, tagFilterOptions, scaleUsageByListId } = props;

  if (isMulti) {
    return (
      <>
        <ColumnHeader icon={Users} title="Leads" subtitle="Multiple drops selected" />
        <div className="flex flex-1 items-center justify-center p-6 text-sm text-muted-foreground">
          Each drop will use its own leads list.
        </div>
      </>
    );
  }

  if (!enrichedLeads.length) {
    return (
      <>
        <ColumnHeader icon={Users} title="Leads" subtitle="Select target list" />
        <div className="flex flex-1 items-center justify-center p-6 text-sm text-muted-foreground">
          No leads lists available
        </div>
      </>
    );
  }

  return (
    <LeadsPickerSection
      leadsLists={enrichedLeads}
      tagColors={perfTagsQuery.data?.tagColors}
      tagsLoading={perfTagsQuery.isLoading}
      tagFilterOptions={tagFilterOptions}
      selectedId={form.leadsListWiserId}
      onSelect={form.handleLeadSelect}
      search={form.leadSearch}
      onSearch={form.setLeadSearch}
      showLeads={form.showLeads}
      onToggleShow={() => form.setShowLeads((v) => !v)}
      usageByListId={scaleUsageByListId}
    />
  );
}
